import CurrentConfiguration from "./CurrentConfiguration";

export default CurrentConfiguration;
